import { IonHeader, IonToolbar, IonButton, IonModal, IonTitle, IonContent } from "@ionic/react";
import React, { useRef } from "react";

interface Props {
    isOpen: boolean;
    onReload: () => void;
}

const LiveUpdateModal: React.FC<Props> = ({ isOpen, onReload }) => {
    const modal = useRef<HTMLIonModalElement>(null);

    return (
        <IonModal
            backdropDismiss={false}
            showBackdrop={true}
            ref={modal}
            isOpen={isOpen}
            initialBreakpoint={0.35}
            breakpoints={[0.35]}
        >
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Update Available</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent class="ion-padding">
                <p>A new version of the app has been downloaded and is ready to install.</p>

                <IonButton color="primary" onClick={onReload} expand="block">
                    Update Now
                </IonButton>
            </IonContent>
        </IonModal>
    );
};

export default LiveUpdateModal;
